<template>
  <div id="app" @contextmenu.prevent="">
    <a-config-provider :locale="$locale">
      <router-view />
    </a-config-provider>
    <!-- 高级搜索 -->
    <div :class="showAdvance ? 'advance-box cur' : 'advance-box'">
      <div class="main-box">
        <div class="tit">高级检索</div>
        <a href="javascript:" class="cls" @click="showAdvance = false"></a>
        <div class="s-tap">
          <span
            @click="tapName = 'searchRecord'"
            :class="tapName === 'searchRecord' ? 'cur' : ''"
          >唱片</span
          >
          <a-divider type="vertical" />
          <span
            @click="tapName = 'searchSong'"
            :class="tapName === 'searchSong' ? 'cur' : ''"
          ><i class="song"></i>曲目</span
          >
          <a-divider type="vertical" />
          <span
            @click="tapName = 'searchMusician'"
            :class="tapName === 'searchMusician' ? 'cur' : ''"
          ><i class="song"></i>乐人</span
          >
          <a-divider type="vertical" />
          <span
            @click="tapName = 'searchCompany'"
            :class="tapName === 'searchCompany' ? 'cur' : ''"
          ><i class="song"></i>机构团体</span
          >
        </div>
        <div class="ipt-box">
          <div v-for="ipt in searchColumns[tapName]" :key="ipt.key" class="ipt">
            <span class="lb">{{ ipt.name }}</span>
            <input type="text" v-model="ipt.value" placeholder="请输入关键词" @keyup="changeHandle"/>
          </div>
        </div>
        <div class="act">
          <a href="javascript:" class="clean" @click="onReset"
          ><i></i>清空重置</a
          >
          <div>
            <a href="javascript:" class="qx" @click="showAdvance = false"
            >取消</a
            >
            <a href="javascript:" class="js" @click="advanceSearch">检索</a>
          </div>
        </div>
      </div>
    </div>
    <ToTop />
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from 'vuex'
import ToTop from '@/components/toTop'
import { eventBus } from "@/util/eventBus";
export default {
  components:{
    ToTop
  },
  data() {
    return {
      showAdvance: false,
      tapName: "searchRecord",
      tapItemName:"searchRecord",
      keyword:null,
      searchColumns: {
        searchSong: [
          {
            logic: "and",
            field: "TI",
            name: "标题",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "CO",
            name: "责任者",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "GENRE",
            name: "体裁",
            value: "",
            type: "0",
          },
            {
            logic: "and",
            field: "BAND",
            name: "乐队",
            value: "",
            type: "0",
          },
          // {
          //   logic: "and",
          //   field: "TOPIC",
          //   name: "内容",
          //   value: "",
          //   type: "0", 
          // },
          {
            logic: "and",
            field: "PL",
            name: "地域",
            value: "",
            type: "0",
          },
        ],
        searchCompany: [
          {
            logic: "and",
            field: "NAME",
            name: "名称",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "CREATED",
            name: "成立时间",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "PL",
            name: "成立地点",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "DES",
            name: "简介",
            value: "",
            type: "0",
          },
        ],
        searchMusician: [
          {
            logic: "and",
            field: "NAME",
            name: "姓名",
            value: "",
            type: "0",
          },
 {
            logic: "and",
            field: "BIRTH",
            name: "生年",
            value: "",
            type: "0",
          },
           {
            logic: "and",
            field: "DEATH",
            name: "卒年",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "PL",
            name: "籍贯",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "BRIEF",
            name: "小传",
            value: "",
            type: "0",
          },
        ],
        searchRecord: [
          {
            logic: "and",
            field: "TI",
            name: "标题",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "CO",
            name: "责任者",
            value: "",
            type: "0",
          },
           {
            logic: "and",
            field: "MAINSBJT",
            name: "主题",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "ORG",
            name: "出版机构",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "IS",
            name: "出版时间",
            value: "",
            type: "0",
          },
          {
            logic: "and",
            field: "PL",
            name: "出版地",
            value: "",
            type: "0",
          },
            {
            logic: "and",
            field: "SSH",
            name: "索书号",
            value: "",
            type: "0",
          },
        ],
      },
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'getUserInfo' // getToDo 不是字符串，对应的是getter里面的一个方法名字 然后将这个方法名字重新取一个别名 todosALise
    })
  },
  created() {
    var token;

    if (this.$route.query.token) {
      token = this.$route.query.token;
      localStorage.setItem('token', token);
    }
    if (this.$route.query.useToken) {
      token = this.$route.query.useToken;
      localStorage.setItem('token', token);
    }
    if (!token) {
      token = localStorage.getItem('token');
    }
    if (token) {
      this.getUserInfo(token);
    }
    const _this = this
    eventBus.$on('advanceChange',function (flag){
      _this.showAdvance = flag
    })
    eventBus.$on('resSetForm',function (flag){
      _this.tapName = flag
      _this.onReset()
    })
    
  },
  methods: {
    changeAdvance() {
      this.showAdvance = true;
    },
    //点击检索，高级搜索点击检索的时候，需判断普通搜索是否有内容，如果有内容，则需要删除
    advanceSearch() {
      const res = this.searchColumns[this.tapName].filter((item) => {
        return !!item.value;
      });
      
      this.showAdvance = this.showAdvance == true ? false : true;
      this.$router.push({
        path:'/search',
        query: {
          keyword: ''
        }
      })
      setTimeout(()=>{
        eventBus.$emit('advanceSearch',res,this.tapName)
      },10)
    },
    // 重置
    onReset() {
      let inputArr = this.searchColumns[this.tapName];
      for (let i = 0, len = inputArr.length; i < len; i++) {
        this.searchColumns[this.tapName][i].value = "";
      }
      eventBus.$emit('clearAdvance')
    },
    getUserInfo(token) {
      axios({
        method: "post",
        url: "https://dhapi.library.sh.cn/management/webapi/cenofmagent/token/account",
        params: {
          token: token,
        },
      })
        .then((res) => {
          if (res.data && res.data.data) {
            this.saveUserInfo(res.data.data);
          } else {
            // token失效
            if (res.data.result == 1) {
              localStorage.removeItem("token");
            }
          }
        })
        .catch((error) => {});
    },
    changeHandle(e) {
      if (e.target.value !== "") {
        if(e.keyCode == 13){
          this.advanceSearch();
        }
      }
    },
    saveUserInfo(data) {
      let userInfo = {
        id: data.id,
        userId: data.userId,
        shLibAskNo: data.shLibAskNo,
        userName: data.userName,
        firstName: data.userName.at(-1),
        roleId: data.roleId,
        roleName: data.roleName,
      };
      // window.localStorage.setItem("userInfo", JSON.stringify(userInfo));
      // //console.log("=========", this.$store);
      this.$store.commit("setUserInfo", userInfo);
    },
  }
}
</script>
<style lang="less" src="../src/assets/style/reset.less"></style>
<style lang="less" src="../src/assets/style/style.less"></style>
